import { Text } from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { Icon } from '@/modules/perseo-billing/ui/react/src/components/beta';

export const BuyNowModalContent = () => {
  const paymentError = useAppSelector((state) => state?.buyNow?.paymentError);

  const title = paymentError?.title;
  const message = paymentError?.message;
  const iconError = paymentError?.contentAssets;

  return (
    <div className="co-flex co-flex-col co-gap-4 co-items-center co-h-full">
      {iconError && (
        <Icon className="co-w-[160px] co-h-[160px]" icon={iconError} />
      )}
      <Text variant="subtitle1" weight={700} color="primary-500">
        {title}
      </Text>
      <Text color="neutral-900" variant="body2" className="co-text-center">
        {message}
      </Text>
    </div>
  );
};
